import { Component, OnInit, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, startWith } from 'rxjs';
import { NonNullableFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../auth.service';
import { NgxSpinnerService } from "ngx-spinner";


import { Bind } from 'primeng/bind';
import { InputText } from 'primeng/inputtext';
import { ButtonDirective } from 'primeng/button';


@Component({
    selector: 'app-password-recover',
    templateUrl: './password-recover.component.html',
    styleUrls: ['./password-recover.component.css'],
    imports: [RouterLink, FormsModule, ReactiveFormsModule, Bind, InputText, ButtonDirective]
})
export class PasswordRecoverComponent implements OnInit {
  private fb = inject(NonNullableFormBuilder);
  private authService = inject(AuthService);
  private spinner = inject(NgxSpinnerService);

  loginForm = this.fb.group({
    user_email: ['', Validators.required],
  });
  formValid = toSignal(
    this.loginForm.statusChanges.pipe(
      map((status) => status === 'VALID'),
      startWith(this.loginForm.valid)
    ),
    { requireSync: true }
  );

  submitted = signal(false);
  error = signal<any>(null);
  loginError = signal('');

  ngOnInit() {
    this.spinner.hide();
  }

  get user_email() {
    return this.loginForm.controls.user_email;
  }

  onSubmit() {
    this.submitted.set(true);
    this.authService.recover_password(this.user_email.value).subscribe({
      next: () => {
        if (this.authService.isLoggedIn()) {
          this.loginError.set('Check email.');
          this.loginForm.reset();
          localStorage.removeItem('currentUser');
        } else {
          this.loginError.set('Username or password is incorrect.');
        }
      },
      error: (error) => this.error.set(error),
    });
  }
}
